import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ReactComponent as CloseIcon } from 'assets/icons/times.svg';
import { ReactComponent as BarsIcon } from 'assets/icons/bars.svg';
import { ReactComponent as JavelinLogo } from 'assets/icons/logo-javelin-nav-top.svg';

const NavbarToggle = ({
  toggleMenu,
  isHamburgerMenuOpen,
  hasHamburgerIcon,
  logoStyle,
  LogoIcon,
  Logo = (
    <Link to="/" className="mx-auto outline-none min-w-28">
      <LogoIcon
        width="135"
        className={`${
          hasHamburgerIcon && isHamburgerMenuOpen
            ? 'hidden'
            : `block ${logoStyle}`
        }`}
      />
    </Link>
  ),
}) => (
  <div
    className={`lg:hidden fixed top-0 left-0 h-16 w-screen bg-white ${
      hasHamburgerIcon && isHamburgerMenuOpen
        ? ''
        : 'border-b items-center flex border-gray-200'
    }`}
  >
    {hasHamburgerIcon && (
      <button
        type="button"
        className="rounded-lg focus:outline-none focus:shadow-outline h-full absolute left-4 top-0 bottom-0 my-auto"
        onClick={toggleMenu}
        data-testid="navbar-toggle"
      >
        {isHamburgerMenuOpen ? (
          <CloseIcon
            data-testid="close-icon"
            className="w-5 h-5 fill-current text-gray-400"
          />
        ) : (
          <BarsIcon
            data-testid="bars-icon"
            className="w-5 h-5 fill-current text-gray-400"
          />
        )}
      </button>
    )}
    {Logo}
  </div>
);

NavbarToggle.propTypes = {
  toggleMenu: PropTypes.func,
  isHamburgerMenuOpen: PropTypes.bool,
  hasHamburgerIcon: PropTypes.bool,
  Logo: PropTypes.node,
  logoStyle: PropTypes.string,
  LogoIcon: PropTypes.object,
};
NavbarToggle.defaultProps = {
  hasHamburgerIcon: true,
  isHamburgerMenuOpen: false,
  logoStyle: '',
  LogoIcon: JavelinLogo,
};
export default memo(NavbarToggle);
